import { MissingFeatureType } from '@shure/shared/angular/data-access/system-api/models';

export enum RoomAdaptStatus {
	Idle = 'IDLE',
	AutoRouteAssociating = 'AUTO_ROUTE_ASSOCIATING',
	AutoRouteOptimizing = 'AUTO_ROUTE_OPTIMIZING',
	RoomCharacterizationPrompting = 'ROOM_CHARACTERIZATION_PROMPTING',
	ContinuityCheck = 'CONTINUITY_CHECK',
	RoomCharacterizationInProgress = 'ROOM_CHARACTERIZATION_IN_PROGRESS',
	GeneratingReport = 'GENERATING_REPORT'
}

export enum SignalContinuityResult {
	Aborted = 'ABORTED',
	Failed = 'FAILED',
	Full = 'FULL',
	None = 'NONE',
	NotAvailable = 'NOT_AVAILABLE',
	Partial = 'PARTIAL'
}

export enum AutoRouteResult {
	Aborted = 'ABORTED',
	Failed = 'FAILED',
	PartiallySuccessful = 'PARTIALLY_SUCCESSFUL',
	Rejected = 'REJECTED',
	Successful = 'SUCCESSFUL'
}

export enum CharacterizationReportResult {
	Aborted = 'ABORTED',
	Failed = 'FAILED',
	NotAvailable = 'NOT_AVAILABLE',
	Successful = 'SUCCESSFUL'
}

export enum CharacterizationMeasurementResult {
	Aborted = 'ABORTED',
	Failed = 'FAILED',
	NotAvailable = 'NOT_AVAILABLE',
	Successful = 'SUCCESSFUL'
}

export interface RoomCharacterizationSummary {
	ambientNoise: number;
	coupling: number;
	distortion: number;
	reverberation: number;
	signalContinuityResult: SignalContinuityResult | null;
	autoRouteResult: AutoRouteResult | null;
	characterizationMeasurementResult: CharacterizationMeasurementResult | null;
	characterizationReportResult: CharacterizationReportResult | null;
}

export type RoomAdaptStepEvent =
	| { type: 'autoRoute'; result: AutoRouteResult }
	| { type: 'signalContinuity'; result: SignalContinuityResult }
	| { type: 'characterizationSummary'; result: CharacterizationMeasurementResult }
	| { type: 'reportGeneration'; result: CharacterizationReportResult };

export interface RoomAdaptDevice {
	id: string;
	name: string;
	roomId: string | null;
	features: {
		roomCharacterization?: {
			readiness: boolean;
			reportDownloadAvailable: boolean;
			summary: RoomCharacterizationSummary | null;
		} & MissingFeatureType;
		roomAdapt?: {
			status: RoomAdaptStatus;
		} & MissingFeatureType;
	};
}

export interface RoomAdaptRoomDevice {
	id: string;
	roomAdaptSupported: boolean;
}
